import { FC, useCallback, useState } from "react"
import { discussionReplyDeleteApi } from "src/domain/api/discussionReply/discussionReplyDeleteApi"
import { DiscussionReply } from "src/domain/entities/discussionReply"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	discussionReply: DiscussionReply
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const DiscussionReplyDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	discussionReply,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleDiscussionReplyDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await discussionReplyDeleteApi({ id: discussionReply.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [discussionReply, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Discussion Reply: ${discussionReply.text}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleDiscussionReplyDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
